import { render, staticRenderFns } from "./CardGallery.vue?vue&type=template&id=35e5ca8e&scoped=true&"
import script from "./CardGallery.vue?vue&type=script&lang=js&"
export * from "./CardGallery.vue?vue&type=script&lang=js&"
import style0 from "./CardGallery.vue?vue&type=style&index=0&id=35e5ca8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5ca8e",
  null
  
)

export default component.exports